var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "84px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.8487,47.5662L49.498,81.171L29.2582,81.171L2.17718,1.88231L28.6872,1.88231L38.8541,26.4957L44.68,1.88231L72.4788,1.88231L80.413,26.4957L87.7685,1.88231L113.578,1.88231L87.0363,81.171L67.8941,81.171L57.8487,47.5662Z",
    style: {
      fill: "black",
      strokeWidth: 2,
      stroke: "rgb(253,242,83)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M101.737,81.171L127.82,1.88231L167.187,1.88231L193.71,81.171L163.726,81.171L158.735,66.8925L135.176,66.8925L130.178,81.171L101.737,81.171ZM147.587,19.4491L136.222,50.8617L158.072,50.8617L147.587,19.4491Z",
    style: {
      fill: "black",
      strokeWidth: 2,
      stroke: "rgb(253,242,83)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M326.965,25.4922L356.582,25.3696L356.582,1.75972L303.023,1.88231C292.92,1.88231 286.92,6.78603 285.009,16.5934C283.112,26.4081 288.528,37.1674 301.271,48.8858C308.994,54.965 307.674,57.8567 297.312,57.5611L260.195,57.5611L254.26,49.982C260.411,48.5181 265.135,46.5061 268.43,43.9461C271.726,41.3788 274.026,38.1986 275.346,34.391C276.665,30.5835 276.593,25.1605 275.129,18.1367C273.226,13.4493 270.226,9.71383 266.123,6.93025C262.026,4.14667 256.791,2.46644 250.416,1.88231L198.805,1.88231L198.805,81.171L227.47,81.171L227.47,54.9794L252.616,81.171L322.789,81.171C334.212,79.2672 340.032,73.4116 340.255,63.597C340.471,53.7896 334.652,43.6864 322.789,33.2877C316.169,27.7999 317.561,25.1966 326.965,25.4922ZM250.914,35.0761C249.666,35.8622 248.52,36.2588 247.452,36.2588L227.47,36.2588L227.47,21.6486L247.402,21.6486C248.282,21.6486 249.371,22.1318 250.661,23.1053C251.967,24.0716 252.709,26.0764 252.89,29.1195C252.818,32.2998 252.161,34.2901 250.914,35.0761Z",
    style: {
      fill: "black",
      strokeWidth: 2,
      stroke: "rgb(253,242,83)"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWars);
export default __webpack_public_path__ + "static/media/wars.731df4d64535bfb7984c3959d2332816.svg";
export { ForwardRef as ReactComponent };